module.exports = __webpack_public_path__ + "img/img06.82c99455.png";